<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="deCode"
    >
      <template v-slot:image="{ row }">
        <b-img
          rounded
          alt="Rounded image"
          width="80px"
          :src="$osscdn(row.deThumbImageCode) || '/image/static/img/nopic.jpg'"
        ></b-img>
      </template>
      <template v-slot:dename="{ row }">
        {{ row.deName }}<br />{{ row.deNameEn }}
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.deStatus === 'Y'
              ? 'success'
              : row.deStatus === 'S'
              ? 'secondary'
              : 'danger'
          "
        >
          {{ row.deStatusName }}
        </el-tag>
      </template>
      <template v-slot:modiinfo="{ row }">
        Modify：{{ row.modifyByName }} / {{ row.modifyDate }}
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="fromLoad2('detail', row.deCode)"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="fromLoad2('edit', row.deCode)"
              v-if="allow('M')"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="delRow([row.deCode])"
              v-show="row.deStatus === 'Y'"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
    <!--分类和客户选择弹框-->
    <el-dialog
      :title="$l('tips_add') || '新增'"
      :visible.sync="dialogVisible2"
      :width="ref === 'batchAdd' ? '1000px' : '600px'"
      :show-close="false"
      destroy-on-close
      :close-on-click-modal="false"
      top="0vh"
    >
      <div style="padding-bottom: 10px" v-if="ref === 'add'">
        <dict-select
          v-model="deCategoryCode"
          filterable
          clearable
          url="/digitalCenter/common/dict/elementCategorySelect"
          size="medium"
          :placeholder="$l('INDEX.check_label_select_category') || '请选择分类'"
          style="width: 100%"
        ></dict-select>
      </div>
      <span slot="footer" class="dialog-footer" v-if="ref === 'add'">
        <el-button @click="dialogCategoryClose" size="small">{{
          $l("add_dialog_btn_cancel") || "取消"
        }}</el-button>
        <el-button type="primary" @click="dialogCategoryStart" size="small">{{
          $l("INDEX.product_dialog_btn_confirm") || "确定"
        }}</el-button>
      </span>
      <div v-if="ref === 'batchAdd'">
        <batch-add
          @close="dialogCategoryClose"
          @saveOk="saveBatchOk"
        ></batch-add>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableAutoHeight from "@/mixins/table-auto-height";

export default {
  mixins: [TableAutoHeight],
  components: {
    BatchAdd: () => import("./batch-add.vue"),
  },
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      ref: "",
      dialogVisible2: false,
      deCategoryCode: "", // 弹窗选择素材分类code
      custCode: "", // 弹窗选择客户code
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => {
            this.$emit("submit");
          },
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: "seq",
          width: 50,
          fixed: "left",
          align: "center",
          type: "seq",
        },
        {
          field: "col-opt",
          title: this.$l("INDEX.table_label_operation") || "操作",
          headerAlign: "center",
          align: "center",
          fixed: "right",
          width: 110,
          slots: {
            default: "opt",
          },
        },
        {
          field: "deNo",
          width: 150,
          title: this.$l("table_label_elements_no") || "素材编号",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "left",
        },
        {
          field: "deImageUrl",
          width: 120,
          title: this.$l("table_label_image") || "图片",
          headerAlign: "center",
          showHeaderOverflow: "title",
          showOverflow: true,
          align: "center",
          slots: {
            default: "image",
          },
        },
        {
          field: "deName",
          minWidth: 250,
          title: this.$l("table_label_name_cn") || "素材名称",
          headerAlign: "center",
          showHeaderOverflow: "title",
          align: "left",
          slots: { default: "dename" },
        },
        {
          field: "deStatus",
          width: 80,
          title: this.$l("table_label_status") || "有效状态",
          align: "center",
          slots: { default: "status" },
        },
        {
          field: "modifyInfo",
          minWidth: 200,
          align: "center",
          title: this.$l("table_label_modifyInfo") || "修改信息",
          slots: { default: "modiinfo" },
        },
      ],
    };
  },
  methods: {
    // 加载表单
    fromLoad2(ref, val = "") {
      this.ref = ref;
      let params = {
        pageType: ref,
        deCode: val,
      };
      if (ref === "add") {
        this.custCode = "";
        this.deCategoryCode = "";
        this.dialogVisible2 = true;
        return;
      } else if (ref === "batchAdd") {
        this.custCode = "";
        this.deCategoryCode = "";
        this.dialogVisible2 = true;
        return;
      }
      // 跳转页面
      this.$router.push({
        name: "resourceManagement-designElementsInfoUpdate",
        params: params,
      });
    },
    saveBatchOk() {
      this.dialogVisible2 = false;
      this.$emit("submit");
    },
    // 选择素材类别弹框关闭后事件
    dialogCategoryClose() {
      this.dialogVisible2 = false;
      this.custCode = "";
      this.deCategoryCode = "";
    },
    dialogCategoryStart() {
      if (!this.deCategoryCode) {
        this.$message.info(
          this.$l("INDEX.check_label_select_category") || "请选择素材类别"
        );
        return false;
      }
      if (this.ref === "add") {
        this.dialogVisible2 = false;
        let param = {
          pageType: "add",
          deCode: this.deCategoryCode + "=" + this.custCode,
        };
        this.$router.push({
          name: "resourceManagement-designElementsInfoUpdate",
          params: param,
        });
        this.custCode = "";
        this.deCategoryCode = "";
      }
    },
    delRow(deCodeList) {
      this.$confirm(
        this.$l("INDEX.tips_question_delete") || "是否删除？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .updateStatusDesignElementsInfoApi({ deCodeList: deCodeList })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
              type: "success",
            });
            this.$emit("submit");
          });
      });
    },
  },
};
</script>
